import { format, isBefore, subDays, subWeeks, getDay, getMonth } from 'date-fns'

const days = [
  'Mandag',
  'Tirsdag',
  'Onsdag',
  'Torsdag',
  'Fredag',
  'Lørdag',
  'Søndag',
]

const shortMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Mai',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Okt',
  'Nov',
  'Des',
]

export const prettyShortDate = timestamp => {
  if (isBefore(subDays(new Date(), 1), timestamp)) {
    return format(timestamp, 'HH:mm')
  } else if (isBefore(subWeeks(new Date(), 1), timestamp)) {
    return days[getDay(timestamp) - 1]
  } else {
    return `${shortMonths[getMonth(timestamp)]} ${format(timestamp, 'D')}`
  }
}



// WEBPACK FOOTER //
// ./src/utils/date.js